(function() {
    'use strict';

    angular
        .module('app')
        .directive('nicescroll', nicescroll);

    nicescroll.$inject = ['$window'];
    
    function nicescroll ($window) {
        // Usage:
        //     <nicescroll></nicescroll>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            $(element).niceScroll({ cursorcolor: "#d1d1d1", cursorwidth: "10px", autohidemode: false });
        }
    }

})();